<template>
  <BaseDialog
    :model-value="modelValue"
    :title="'Cadastrar Empresa do Cliente'"
    :icon="'mdi-domain-plus'"
    :loading="loading"
    @update:model-value="updateDialog"
    @salvar="salvarEmpresa"
    max-width="800px"
  >
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="empresa.razao_social"
            label="Razão Social"
            :rules="[rules.required]"
            required
            prepend-inner-icon="mdi-office-building"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="empresa.nome_fantasia"
            label="Nome Fantasia"
            prepend-inner-icon="mdi-store"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="empresa.cnpj_cpf"
            label="CNPJ/CPF"
            :rules="[rules.required]"
            required
            prepend-inner-icon="mdi-card-account-details"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="empresa.inscricao_estadual"
            label="Inscrição Estadual"
            :rules="[rules.required]"
            prepend-inner-icon="mdi-file-document-outline"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="empresa.email"
            label="Email"
            :rules="[rules.email]"
            prepend-inner-icon="mdi-email"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="empresa.telefone"
            label="Telefone"
            prepend-inner-icon="mdi-phone"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="empresa.cep"
            label="CEP"
            prepend-inner-icon="mdi-map-marker-radius"
          />
        </v-col>
        <v-col cols="12" sm="8" md="5">
          <v-text-field
            v-model="empresa.endereco"
            label="Endereço"
            :rules="[rules.required]"
            prepend-inner-icon="mdi-map-marker"
            required
            clearable
          />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-text-field
            v-model="empresa.numero_endereco"
            label="Número"
            :rules="[rules.required]"
            prepend-inner-icon="mdi-numeric"
            required
            clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="empresa.bairro"
            label="Bairro"
            :rules="[rules.required]"
            prepend-inner-icon="mdi-home-city"
            required
            clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="empresa.complemento"
            label="Complemento"
            prepend-inner-icon="mdi-home-outline"
            clearable
          />
        </v-col>
      </v-row>
    </v-form>
    <v-card class="mb-2" flat outlined>
      <v-card-title class="subtitle-1 font-weight-bold">
        Município
        <v-btn
          icon
          variant="tonal"
          size="small"
          color="primary"
          class="ml-2"
          @click="dialogBuscaMunicipio = true"
          title="Buscar município"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <span class="ml-3 municipio-caption">
          Selecione o município pela lupa
        </span>
      </v-card-title>
      <v-card-text>
        <div v-if="empresa.cod_municipio">
          <v-row dense>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model.number="empresa.cod_municipio"
                label="Código Município"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-city"
                readonly
                type="number"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="empresa.nome_municipio"
                label="Nome Município"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-city-variant"
                readonly
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model.number="empresa.codigo_uf"
                label="Código UF"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-map"
                readonly
                type="number"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="empresa.sigla_uf"
                label="Sigla UF"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-map-outline"
                readonly
                clearable
              />
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </BaseDialog>
  <DialogBusca
    v-model:open="dialogBuscaMunicipio"
    :rota-busca="'municipios'"
    @selecionado="selecionarMunicipio"
  />
</template>

<script>
import { mapActions } from "vuex";
import api from "../services/api";
import rulesMixin from "@/mixins/rulesMixin";
import DialogBusca from "./DialogBusca.vue";
import BaseDialog from "./comum/BaseDialog.vue";

export default {
  mixins: [rulesMixin],
  components: { DialogBusca, BaseDialog },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    codcliente: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    loading: false,
    dialogBuscaMunicipio: false,
    empresa: {
      razao_social: "",
      nome_fantasia: "",
      cnpj_cpf: "",
      inscricao_estadual: "",
      endereco: "",
      complemento: "",
      bairro: "",
      numero_endereco: "",
      cep: "",
      email: "",
      telefone: "",
      cod_municipio: null,
      nome_municipio: "",
      codigo_uf: null,
      sigla_uf: "",
    },
  }),
  watch: {
    modelValue(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },
  methods: {
    ...mapActions(["triggerFeedback"]),
    updateDialog(val) {
      this.$emit("update:modelValue", val);
    },
    fecharDialog() {
      this.$emit("update:modelValue", false);
    },
    resetForm() {
      this.empresa = {
        razao_social: "",
        nome_fantasia: "",
        cnpj_cpf: "",
        inscricao_estadual: "",
        endereco: "",
        complemento: "",
        bairro: "",
        numero_endereco: "",
        cep: "",
        email: "",
        telefone: "",
        cod_municipio: null,
        nome_municipio: "",
        codigo_uf: null,
        sigla_uf: "",
      };
      this.valid = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    async salvarEmpresa() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;

      const payload = {
        ...this.empresa,
        codcliente: this.codcliente,
      };

      try {
        await api.post("/empresacliente/", payload);
        this.triggerFeedback({
          message: "Empresa cadastrada com sucesso!",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.fecharDialog();
        this.$emit("empresa-cadastrada");
      } catch (error) {
        this.triggerFeedback({
          message: "Erro ao cadastrar empresa!",
          color: "error",
          icon: "mdi-alert-circle",
        });
        console.error(error);
      }
      this.loading = false;
    },
    selecionarMunicipio(municipio) {
      this.empresa.cod_municipio = municipio.codmunicipioibge;
      this.empresa.nome_municipio = municipio.nome_municipio;
      this.empresa.codigo_uf = municipio.cod_uf;
      this.empresa.sigla_uf = municipio.sigla_uf;
    },
  },
};
</script>
<style scoped>
.custom-dialog-card {
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.custom-dialog-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
}
</style>

<style scoped>
.custom-dialog-card {
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.custom-dialog-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
}
</style>
